// Lightweight metadata registry for the blog index, kept separate from
// the post components so the index page doesn't need to import full post
// bodies just to list them.
export const POSTS = [
  {
    slug: 'do-doormats-kill-bacteria',
    category: 'Hygiene Science',
    title: "Do Doormats Kill Bacteria? What Shoe-Sole Studies Actually Show",
    excerpt: 'What shoe-sole microbiology studies actually find, why 96% of shoes carry harmful bacteria, and what it takes to actually disinfect an entryway.',
    date: '2027-03-02',
    readTime: '11 min read',
  },
  {
    slug: 'smart-vs-traditional-doormat',
    category: 'Product',
    title: 'Smart Disinfectant Doormat vs. Traditional Doormat: What Actually Changes',
    excerpt: 'A practical comparison between smart disinfectant doormats and traditional doormats: hygiene outcomes, cost, and maintenance.',
    date: '2027-02-18',
    readTime: '10 min read',
  },
  {
    slug: 'uv-vs-spray-disinfection',
    category: 'Product',
    title: 'UV Sanitizer vs. Spray Disinfection for Entryways: Which Technology Wins',
    excerpt: "How each disinfection mechanism actually eliminates pathogens on shoe soles, and why it matters more than the marketing.",
    date: '2027-01-30',
    readTime: '10 min read',
  },
  {
    slug: 'entryway-hygiene-hospitals-childcare',
    category: 'Verticals',
    title: 'Entryway Hygiene for Hospitals, Clinics and Childcare Facilities',
    excerpt: 'Why entryway hygiene deserves more attention in healthcare and childcare settings, and how automated disinfection fits existing protocols.',
    date: '2027-01-12',
    readTime: '11 min read',
  },
  {
    slug: 'smart-doormat-buyers-guide-australia',
    category: "Buyer's Guide",
    title: "Choosing a Smart Doormat in Australia: A Buyer's Guide for 2027",
    excerpt: 'What to evaluate, what it costs, and what to expect ahead of the 2027 Australian market launch.',
    date: '2026-12-05',
    readTime: '10 min read',
  },
];
